import { COMPONENT_COLOR_THEMES, COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import { Theme } from 'shared/types';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  backgroundImage?: {
    _?: string;
    md?: string;
  };
  textColorTheme?: Theme;
  title?: string;
  subtitle?: string;
  warrantyItems?: {
    graphics?: string;
    title?: string;
    years?: string;
    andOr?: string;
    distance?: string;
  }[];
  disclaimers?: {
    text?: string;
  }[];
}

const propsSchema: PropsSchemaList = [
  {
    key: 'backgroundImage',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: '_',
        label: 'Mobile (or Base)',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'md',
        label: 'Desktop',
        type: types.S3_ASSET_URL,
      },
    ],
  },
  {
    key: 'textColorTheme',
    label: 'Text Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES,
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'subtitle',
    label: 'Subtitle',
    type: types.TEXT,
  },
  {
    key: 'warrantyItems',
    label: 'Warranty Items',
    type: types.ARRAY,
    children: [
      {
        key: 'graphics',
        label: 'Graphics',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'years',
        label: 'Years',
        type: types.TEXT,
      },
      {
        key: 'andOr',
        label: 'And/Or',
        type: types.TEXT,
      },
      {
        key: 'distance',
        label: 'Distance',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'disclaimers',
    label: 'Disclaimers',
    type: types.ARRAY,
    children: [
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
      },
    ],
  },
];

const defaultProps: Props = {
  backgroundImage: {
    _: 'https://genesis-cdn.ff.com/assets/pages/service/vehicle-base-background-default.jpg',
    md: 'https://genesis-cdn.ff.com/assets/pages/service/vehicle-base-background-default.jpg',
  },
  textColorTheme: 'LIGHT',
  title: 'FF Service Commitment',
  subtitle: 'New Vehicle Warranty',
  warrantyItems: [
    {
      graphics: 'https://genesis-cdn.ff.com/assets/pages/service/comprehensive.svg',
      title: 'Comprehensive Warranty',
      years: '5 years',
      andOr: 'or',
      distance: '60,000 Miles',
    },
    {
      graphics: 'https://genesis-cdn.ff.com/assets/pages/service/roadside.svg',
      title: 'Roadside Assistance',
      years: '5 years',
      andOr: 'and',
      distance: 'Unlimited Miles',
    },
    {
      graphics: 'https://genesis-cdn.ff.com/assets/pages/service/powertrain.svg',
      title: 'Powertrain Warranty',
      years: '8 years',
      andOr: 'or',
      distance: '120,000 Miles',
    },
    {
      graphics: 'https://genesis-cdn.ff.com/assets/pages/service/perforation.svg',
      title: 'Perforation',
      years: '12 years',
      andOr: 'and',
      distance: 'Unlimited Miles',
    },
    {
      graphics: 'https://genesis-cdn.ff.com/assets/pages/service/battery.svg',
      title: 'Battery Warranty',
      years: '8 years',
      andOr: 'or',
      distance: '100,000 Miles',
    },
  ],
  disclaimers: [
    {
      text: `1. For further details, please review the New Vehicle Limited Warranty. 
      This summary applies only to vehicles purchased directly from Faraday Future on or after the date listed on the New Vehicle Limited Warranty`,
    },
    {
      text: `2. This summary applies only to vehicles purchased directly from Faraday Future on or after the date listed on the New Vehicle Limited Warranty; 
      any Faraday Future vehicles purchased prior to that date are subject to the applicable New Vehicle Limited Warranty effective as of the date of 
      purchase of such vehicle directly from Faraday Future.`,
    },
  ],
};

export default {
  title: 'Service Commitment',
  id: 'ServiceCommitment',
  propsSchema,
  defaultProps,
}
